/** Une clases ignorando `false`, `null` y `undefined`. Sin dependencias. */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
